import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Input, notification, Tag } from "antd";
import Cookies from "js-cookie";
import { backendURL } from "../Globals";
import "../NewsComponent.css";

/* ── Entrada de noticia estilo lista artículo ──────────────── */
const NewsCard = ({ date, tag, tagColor, title, children, adminActions }) => (
  <div style={{ paddingBottom: 22, marginBottom: 22, borderBottom: '1px solid #ebebeb' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 5 }}>
      {date && <span style={{ fontSize: 12, color: '#aaa', fontVariantNumeric: 'tabular-nums' }}>{date}</span>}
      {tag && <Tag color={tagColor || 'blue'} style={{ fontSize: 11, margin: 0, lineHeight: '18px' }}>{tag}</Tag>}
    </div>
    <div style={{ fontSize: 15.5, fontWeight: 700, color: '#007398', marginBottom: 7, lineHeight: 1.4, cursor: 'default' }}>
      {title}
    </div>
    {children && <div style={{ fontSize: 13.5, color: '#555', lineHeight: 1.75 }}>{children}</div>}
    {adminActions}
  </div>
);

const NewsComponent = () => {
    const [news, setNews] = useState([]);
    const [newIn2026, setNewIn2026] = useState([]);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [showAdminPanel, setShowAdminPanel] = useState(false);
    const [newNews, setNewNews] = useState({ title: "", content: "", date: "" });

    useEffect(() => {
        fetchNews();
        fetchNewIn2026();
        const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
        setIsLoggedIn(!!apiKey);
        setShowAdminPanel(!!apiKey);
    }, []);

    const fetchNews = async () => {
        try {
            const response = await axios.get(`${backendURL}/news`);
            setNews(response.data);
        } catch (error) {
            console.error("Error fetching news:", error);
        }
    };

    const fetchNewIn2026 = async () => {
        try {
            const response = await axios.get(`${backendURL}/journals/new-in-2026`);
            setNewIn2026(response.data);
        } catch (error) {
            console.error("Error fetching new-in-2026:", error);
        }
    };

    const handleAddNews = async () => {
        const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
        if (!apiKey) { notification.error({ message: "No estás autenticado" }); return; }
        const today = new Date().toISOString().split("T")[0];
        try {
            const response = await axios.post(`${backendURL}/news`, { ...newNews, date: today }, {
                headers: { Authorization: `Bearer ${apiKey}` }
            });
            if (response.data.success) {
                setNews([{ ...newNews, date: today, id: response.data.newsId }, ...news]);
                setNewNews({ title: "", content: "", date: "" });
                notification.success({ message: "Noticia añadida correctamente" });
            }
        } catch (error) {
            notification.error({ message: "Error al añadir la noticia" });
        }
    };

    const handleEditNews = async (id, updatedTitle, updatedContent) => {
        const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
        if (!apiKey) return;
        try {
            await axios.put(`${backendURL}/news/${id}`, { title: updatedTitle, content: updatedContent }, {
                headers: { Authorization: `Bearer ${apiKey}` }
            });
            setNews(news.map(n => (n.id === id ? { ...n, title: updatedTitle, content: updatedContent } : n)));
            notification.success({ message: "Noticia editada correctamente" });
        } catch (error) {
            notification.error({ message: "Error al editar la noticia" });
        }
    };

    const handleDeleteNews = (id) => {
        if (!window.confirm("¿Eliminar esta noticia?")) return;
        const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
        if (!apiKey) return;
        axios.delete(`${backendURL}/news/${id}`, { headers: { Authorization: `Bearer ${apiKey}` } })
            .then(() => { setNews(news.filter(n => n.id !== id)); notification.success({ message: "Noticia eliminada" }); })
            .catch(() => notification.error({ message: "Error al eliminar la noticia" }));
    };

    return (
        <div>
            {/* Header — full width */}
            <div style={{ paddingTop: 28, paddingBottom: 4, textAlign: 'center', background: '#fafafa' }}>
                <div style={{
                    fontSize: 22, fontWeight: 700, color: '#1a1a1a',
                    letterSpacing: -0.3, lineHeight: 1.3,
                    fontFamily: "'Inter','Segoe UI',sans-serif",
                    padding: '0 24px',
                }}>
                    Novedades
                </div>
                <div style={{ fontSize: 13, color: '#888', marginTop: 6, paddingBottom: 16 }}>
                    Información actualizada con todo lo que tenga que ver con acuerdos transformativos
                </div>
            </div>

            <div style={{ maxWidth: 760, margin: '32px auto', padding: '0 24px 48px' }}>

                {/* Noticia fija: Nueva página web */}
                <NewsCard
                    date="Mayo 2026"
                    tag="Portal"
                    tagColor="purple"
                    title="Nueva página web"
                >
                    Después de un primer intento de automatización y centro de información para la gestión de los acuerdos transformativos en la Universidad de Oviedo,
                    la biblioteca ofrece ahora un recurso mucho más amplio que integra varias perspectivas de la publicación en acceso abierto: acuerdos transformativos,
                    publicación en revistas diamante, precios de APCs para revistas no elegibles por acuerdo transformativo, y más.
                </NewsCard>

                {/* Noticia dinámica: Nuevas revistas en 2026 */}
                {newIn2026.length > 0 && (
                    <NewsCard
                        date="2026"
                        tag="Nuevas revistas"
                        tagColor="green"
                        title={`Nuevas revistas incorporadas en 2026 (${newIn2026.length})`}
                    >
                        <p style={{ marginBottom: 10 }}>
                            Las siguientes revistas se incorporan a los acuerdos transformativos a partir de 2026:
                        </p>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                            {newIn2026.map((j, i) => (
                                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <Tag color="default" style={{ fontSize: 11, fontFamily: 'monospace', flexShrink: 0 }}>{j.publisher}</Tag>
                                    <span style={{ fontSize: 13, color: '#333' }}>{j.title}</span>
                                </div>
                            ))}
                        </div>
                    </NewsCard>
                )}

                {/* Noticias de la base de datos */}
                {news.length > 0 && (
                    <>
                        {news.map(n => (
                            <NewsCard
                                key={n.id}
                                date={n.date}
                                tag="Aviso"
                                tagColor="default"
                                title={n.title}
                                adminActions={isLoggedIn && showAdminPanel && (
                                    <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                                        <Button size="small" onClick={() => {
                                            const updatedTitle = prompt("Editar título:", n.title);
                                            const updatedContent = prompt("Editar contenido:", n.content);
                                            if (updatedTitle && updatedContent) handleEditNews(n.id, updatedTitle, updatedContent);
                                        }}>Editar</Button>
                                        <Button size="small" danger onClick={() => handleDeleteNews(n.id)}>Eliminar</Button>
                                    </div>
                                )}
                            >
                                {n.content}
                            </NewsCard>
                        ))}
                    </>
                )}

                {/* Admin: añadir noticias */}
                {isLoggedIn && (
                    <div style={{ marginTop: 24 }}>
                        <Button type="default" size="small" onClick={() => setShowAdminPanel(!showAdminPanel)}>
                            {showAdminPanel ? "Ocultar administración" : "Administrar noticias"}
                        </Button>
                        {showAdminPanel && (
                            <div style={{ marginTop: 16, padding: 16, background: '#fafafa', borderRadius: 8, border: '1px solid #e8e8e8' }}>
                                <div style={{ fontWeight: 600, marginBottom: 12 }}>Añadir nueva noticia</div>
                                <Input
                                    placeholder="Título"
                                    value={newNews.title}
                                    onChange={e => setNewNews({ ...newNews, title: e.target.value })}
                                    style={{ marginBottom: 8 }}
                                />
                                <Input.TextArea
                                    placeholder="Contenido"
                                    value={newNews.content}
                                    onChange={e => setNewNews({ ...newNews, content: e.target.value })}
                                    rows={3}
                                    style={{ marginBottom: 8 }}
                                />
                                <Button type="primary" onClick={handleAddNews}>Añadir</Button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default NewsComponent;
